import React, {createContext, Fragment, useContext, useEffect, useState} from "react";
import {ServerContext} from "../../serverContext/ServerProvider";
import {Image} from "../Image";
import {Loader} from "../Loader";

export const ModalContext = createContext()

export const ModalProvider = ({children}) => {
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(true)
    const {getAllPics, pics, addPic, removePic} = useContext(ServerContext)
    const [selectCallback, setSelectCallback] = useState(null)

    useEffect(() => {
        async function wtf() {
            await getAllPics(() => {
                setLoading(false)
            })
        }

        wtf()
    }, [])

    const showModal = (callback) => {
        setSelectCallback(() => callback)
        setVisible(true)
    }

    const imgClickHandler = (src) => {
        if(selectCallback) {
            selectCallback(src)
        }
        setVisible(false)
    }

    const uploadPicHandler = (e) => {
        const file = e.target.files[0]
        if(file) {
            addPic(file)
        }
    }

    const removePicHandler = (src) => {
        removePic(src)
    }

    return (
        <ModalContext.Provider value={{showModal}}>
            {children}
            <div className={"modal_window" + (visible ? '' : ' hidden')}>
                {loading ? <Loader/> : (
                    <Fragment>
                        <button
                            className="close_button"
                            onClick={() => setVisible(false)}
                        >
                            X
                        </button>
                        {pics.map((pic, index) => (
                            <Image
                                key={index}
                                src={pic}
                                onClick={() => imgClickHandler(pic)}
                                removeHandler={removePicHandler}
                            />
                        ))}
                        <input
                            type="file"
                            id='newPic'
                            name='image'
                            style={{display: 'none'}}
                            onChange={e => uploadPicHandler(e)}
                        />
                        <div className='add_wrapper'>
                            <button onClick={() =>
                                document.getElementById('newPic').click()
                            }>Add pic
                            </button>
                        </div>

                    </Fragment>
                )}
            </div>
        </ModalContext.Provider>
    )
}